const Form = (props) => {
  return (
    <div className="col-xl-12 col-lg-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{props.title}</h4>
        </div>
        <div className="card-body">
          <div className="basic-form">
            <form onSubmit={props.onSubmit}>{props.children}</form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
